import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchRateHistories } from "../../actions/callrecorder/rateHistoriesActions";

export interface RateHistoryInterface {
  id: number;
  rate_id: number;
  csv_import_id: number | null;

  previous_cost_per_min: string;
  previous_raw_cost: string;
  previous_currency_iso: string;

  new_cost_per_min: string;
  new_raw_cost: string;
  new_currency_iso: string;

  source: string;
  changed_at: string;
  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<RateHistoryInterface>();

const slice = createSlice({
  name: 'rateHistories',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRateHistories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRateHistories.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.rateHistories;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchRateHistories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectRateHistoryById,
  selectIds: selectRateHistoryIds,
  selectEntities: selectRateHistoryEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.rateHistories);
